import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import styles from "../styles/App.module.css";

type InfoRowProps = {
  icon: LucideIcon;
  title: string;
  hint?: string;
  children?: ReactNode;
};

export function InfoRow({ icon: Icon, title, hint, children }: InfoRowProps) {
  return (
    <div className={styles.infoRow}>
      <Icon aria-hidden="true" size={30} strokeWidth={2.4} />
      <span>
        <strong>{title}</strong>
        {hint ? <small>{hint}</small> : null}
        {children}
      </span>
    </div>
  );
}
